module.exports = __webpack_public_path__ + "static/media/vip-trophy-2.276f2a00.png";